import { SecureRoute } from '@tailosinc/bender-auth-react-cognito-hook';
import React from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import AuthPage from '../../components/AuthPage';
import ErrorComponent from '../../components/ErrorComponent';
import RenderWrapper from './render-wrapper';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <SecureRoute>
        {RenderWrapper}
      </SecureRoute>
    ),
    children: [
      {
        path: '/auth',
        element: <AuthPage />,
      },
      {
        path: '/page-not-found',
        element: <ErrorComponent statusCode={404} baseUrl={window.location.origin} />,
      },
      {
        path: '/runs',
      },
      {
        path: '/robots',
      },
      {
        path: '/settings',
        children: [
          {
            path: '/settings/profile',
          },
          {
            path: '/settings/notifications',
          },
          {
            path: '/settings/api-tokens',
          },
          {
            path: '/settings/security',
          },
          {
            path: '/settings/assign-robots',
          },
          {
            path: '/settings/team-members',
          },
          {
            path: '/settings/team-notifications',
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/page-not-found" replace />,
  },
]);

const Root = () => (
  <RouterProvider router={router} />
);

export default Root;
